import { createClient } from '@supabase/supabase-js';
import { firebaseAuth } from './firebase';

// Keys come from .env (Vite): VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY
const url = import.meta.env.VITE_SUPABASE_URL as string;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

// Auth is handled by Firebase, not Supabase Auth. We hand Supabase the
// current Firebase user's ID token on every request via `accessToken`.
// Supabase verifies it (Third-Party Auth → Firebase) and applies RLS using
// the Firebase UID (auth.jwt()->>'sub'). Anonymous visitors (QR self-order)
// have no Firebase user, so this returns null and the public anon key is used.
export const supabase = createClient(url, anonKey, {
  db: { schema: 'ezydine' },
  accessToken: async () => (await firebaseAuth.currentUser?.getIdToken()) ?? null,
});

